const state = {
    info: {
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        nfc: null,
        phone: null,
        budget: null,
        role: null,
        role_text: null,
        company_id: null,
        location_id: null,
        shift_id: null,
        change_pass: null,
        status: null
    }
};
const actions = {};
const mutations = {
    info(state, info) {
        state.info = info;
    }
};
const getters = {
    info: state => state.info
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
